import React from 'react';
import {
  Datagrid,
  TextInput,
  Resource,
  TextField,
  Filter as RAFilter,
} from 'react-admin';
import { AppList } from 'components/CRUD';
import Icon from '@material-ui/icons/Group';

const Filter = props => (
  <RAFilter {...props}>
    <TextInput source="email" alwaysOn />
  </RAFilter>
);

export const List = props => {
  return (
    <AppList permission='management-users' {...props} filters={<Filter />}>
      <Datagrid>
        <TextField source='email' label='Email' />
      </Datagrid>
    </AppList>
  )
}

const Admin = () => <Resource name="User" options={{label: 'Users'}} list={List} icon={Icon} />;

export default Admin;